import React, {Fragment, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {Card, Button, Intent} from '@blueprintjs/core';
import {Label, TextField} from 'worksource-ui';
import {useMutation} from '@apollo/react-hooks';
import {gql} from 'apollo-boost';

import {showError, showWSErrors, showGQLError} from 'utils/toaster';
import withAuthLayout from 'layouts/auth/view';

const REQUEST_RESET = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email) {
      success,
      errors {
        title,
        message,
      },
    },
  }
`;

const AuthRequestPasswordResetPage = () => {
  ////
  // Hooks
  //
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [requestReset, {loading}] = useMutation(REQUEST_RESET, {
    onCompleted: ({requestPasswordReset: {errors}}) => {
      if (errors.length > 0) {
        showWSErrors({errors});
      } else {
        setDone(true);
      }
    },
    onError: error => showGQLError({error}),
  });

  ////
  // Events
  //
  const submit = (e) => {
    e.preventDefault();
    if (email.length < 5) {
      showError({message: 'Email is invalid'});
      return;
    }
    requestReset({variables: {email}});
  };

  ////
  // Render
  //
  return (
    <Card className="layouts-auth--card">
      {done && (
        <Fragment>
          <h2>Success</h2>
          <p>
            If there is an account associated with <b>{email}</b>, you will
            soon receive an email with further instructions on how to reset
            your password.
          </p>
          <Button
            intent={Intent.PRIMARY}
            text="Done"
            onClick={() => history.push('/auth/login')}
          />
        </Fragment>
      )}
      {!done && (
        <Fragment>
          <h2>Reset Password</h2>
          <p>
            To reset your password, enter the email address you use to login to
            WorkSource. A link will be emailed to this address which will let you
            reset your password.
          </p>
          <form onSubmit={submit}>
            <Label text="Email address" required>
              <TextField
                value={email}
                placeholder="Email address"
                onChange={e => setEmail(e.target.value)}
              />
            </Label>
            <Button
              intent={Intent.PRIMARY}
              text="Send email"
              loading={loading}
              disabled={loading}
              onClick={submit}
            />
            <Button
              minimal
              text="Cancel"
              disabled={loading}
              onClick={() => history.push('/auth/login')}
            />
          </form>
        </Fragment>
      )}
    </Card>
  );
};

export default withAuthLayout()(AuthRequestPasswordResetPage);
